(function($) {
  let $modals = $(".modal-wrapper");
  $modals.attr("aria-hidden", "true");

  let $closeModalButtons = $(".modal-close");

  $closeModalButtons.on("click", function() {
    let $activeModal = $('.modal-wrapper[aria-hidden="false"]');
    $activeModal.attr("aria-hidden", "true");
    $activeModal.attr("tabindex", -1);
  });

  let $openSwiperModalButtons = $("[data-open-modal]");
  // Add listeners to buttons
  $openSwiperModalButtons.each(function() {
    let modalId = $(this).data("open-modal");
    $(this).on("click", function() {
      let $modal = $(`.modal-wrapper[data-modal="${modalId}"]`);
      let slideId = $(this).data("slide-id") + 1;
      $modal.find(".swiper")[0].swiper.slideTo(slideId, 0);
      $modal.attr("aria-hidden", "false");
      $modal
        .find(`.slide[swiper-slide-index="${slideId}"]`)
        .attr("aria-hidden", "false");
      $modal.attr("tabindex", 1);
    });
  });
})(jQuery);
